import { io, option, optionT } from 'fp-ts'

type IOOption<A> = io.IO<option.Option<A>>

const T = optionT.getOptionM(io.io)

export const fold = <A, B>(onNone: () => io.IO<B>, onSome: (a: A) => io.IO<B>) =>
  (ma: IOOption<A>): io.IO<B> =>
    T.fold(ma, onNone, onSome)
